import { useCallback, useContext } from 'react'

import WebsocketActionsContext from '@/common/context/websocketActions/WebsocketActionsContext'

import { getPendingWebsocketAction } from './helpers'

const useWebsocketActions = workspace => {
  const {
    pendingActions,
    setPendingWebsocketAction: setForWorkspace,
    clearPendingWebsocketAction: clearForWorkspace,
  } = useContext(WebsocketActionsContext)

  const pendingWebsocketAction = pendingActions[workspace] || null

  const setPendingWebsocketAction = useCallback(
    (type, response) => setForWorkspace(workspace, getPendingWebsocketAction(type, response)),
    [setForWorkspace, workspace]
  )

  const clearPendingWebsocketAction = useCallback(() => clearForWorkspace(workspace), [clearForWorkspace, workspace])

  return { pendingWebsocketAction, setPendingWebsocketAction, clearPendingWebsocketAction }
}

export default useWebsocketActions
